<template>
    <div class="d-flex justify-center">
        <v-dialog
            v-model="isDialogOpened"
            max-width="400"
            persistent
        >
            <template v-slot:activator="{ on }">
                <v-btn class="primary basic-info__savechange" dark v-on="on">
                    <v-icon left>mdi-message</v-icon> Napsat zprávu
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline">
                    Poslat zprávu hráči {{ recipient.nickname }}
                </v-card-title>
                <v-card-text>
                    <v-textarea
                        dark
                        v-model.trim="message"
                        label="Zpráva"
                    ></v-textarea>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="primary" dark text :disabled="isSending" @click.stop="isDialogOpened = false">Zavřít</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark :disabled="!canSend" :loading="isSending" @click.prevent="onSend">Odeslat</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { MESSAGE_SEND_REQUEST } from '../../store/actions/message';

    export default {
        name: 'UserMessageDialog',
        props: {
            recipient: {
                type: Object,
                required: true,
            },
        },
        data () {
            return {
                isDialogOpened: false,
                isSending: false,
                message: '',
            };
        },
        computed: {
            showErrorMessage () {
                return this.errorMessage !== '';
            },
            showSuccessMessage () {
                return this.successMessage !== '';
            },
            canSend () {
                return this.message !== '';
            },
        },
        methods: {
            async onSend () {
                if (!this.canSend) {
                    return;
                }

                const message = {
                    message: this.message,
                    recipient: this.recipient.id,
                };

                try {
                    this.isSending = true;
                    await this.$store.dispatch('message/' + MESSAGE_SEND_REQUEST, message);
                    this.$toast.success('Zpráva byla úspěšně odeslána.');
                    this.message = '';
                    this.isDialogOpened = false;
                } catch (e) {
                    this.$toast.error('Došlo k chybě při odesílání zprávy. Zkuste to později.');
                } finally {
                    this.isSending = false;
                }
            },
        },
    }
</script>
